import dayjs from 'dayjs';

// The API serialises UTC timestamps WITHOUT an offset, so dayjs parses them as
// local time and formats the same digits back out. That round trip is what
// keeps them UTC on screen -- which is why every label on this page says UTC.
// Do not add a 'Z' or the utc plugin here without relabelling every column.
export const fmtUtc = (v) => (v ? dayjs(v).format('DD MMM HH:mm') : '—');

export const fmtUtcFull = (v) => (v ? dayjs(v).format('DD MMM YYYY HH:mm') : '—');

export const fmtDate = (v) => (v ? dayjs(v).format('DD MMM YYYY') : '—');

export const fmtNight = (v) => (v ? dayjs(v).format('ddd DD MMM') : '—');

export function fmtDuration(seconds) {
  if (seconds == null) return '—';
  const s = Math.max(0, Math.round(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`;
  if (m > 0) return `${m}m ${String(s % 60).padStart(2, '0')}s`;
  return `${s}s`;
}

export const fmtCount = (n) => (n == null ? '—' : Number(n).toLocaleString('en-US'));

// Run and step Status values from etl.RunLog / etl.RunStep, mapped to antd Tag colours.
export function statusColor(status) {
  switch (status) {
    case 'Succeeded':
    case 'Complete':
      return 'success';
    case 'Failed':
      return 'error';
    case 'Aborted':
    case 'PartialSuccess':
      return 'warning';
    case 'Running':
      return 'processing';
    default:
      return 'default';
  }
}
